import React, { useEffect, useMemo, useState } from 'react'
import { FormulaParser } from '@cicero/data/formulas'
import { IFormElementProps } from '@cicero/ui/forms'
import { TextField } from '@cicero/ui'

interface IFormulaCellProps extends IFormElementProps<string> {
  label: string
}

export const FormulaCell = ({ ...restOfParams }: IFormulaCellProps) => {
  return <TextField variant="outlined" {...restOfParams} />
  // const parser = useMemo(() => new FormulaParser(), [name])
  // return <Autocomplete
  //   value={value}
  //   options={parser.funcs}
  //   selectOnFocus
  //   clearOnBlur
  //   handleHomeEndKeys
  //   freeSolo
  //   renderOption={(opt) => {
  //     return <Typography><strong>{opt.key}</strong> - {opt.description}</Typography>
  //   }}
  //   renderInput={(params) => <TextField {...restOfParams} {...params} variant="outlined" autoComplete="off" /> }
  //   onChange={(e, newValue) => {
  //     // const { action } = newValue as any
  //     console.log(newValue, e)
  //     onChange(e)
  //   }}
  //   filterOptions={(opts, params) => {
  //     return opts
  //   }}
  // />
}

export const FormulaRenderer = ({ value, label }: { value: string, label?: string }) => {
  const [displayValue, setDisplayValue] = useState('')
  const parser = useMemo(() => new FormulaParser(), [label])

  useEffect(() => {
    if (value.startsWith('=')) {
      setDisplayValue('LOADING...')
      parser.calculate(value).then(v => {
        setDisplayValue(v)
      }).catch((e) => {
        setDisplayValue(e.message)
      })
      // use service to parse
    } else {
      setDisplayValue(value)
    }
  }, [value])

  return <>{displayValue}</>
}
